import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import { ActivityForwardFragnetFilter } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/ActivityForwardFragnet/components/ActivityForwardFragnetFilter/ActivityForwardFragnetFilter';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { CustomizedFormErrorMessage } from 'components/common';

export const ActivityForwardFragnet = ({ isSelected, onFiltersChanged }) => {
    const {
        control,
        formState: { errors },
        trigger,
        watch,
    } = useFormContext<IFields>();
    return isSelected ? (
        <>
            <div className={classes.selectWrapper}>
                <span className={classes.title}>Activity Forward Fragnet</span>

                <Controller
                    render={({ field }) => (
                        <ActivityForwardFragnetFilter
                            {...field}
                            onChange={async (newValue) => {
                                field.onChange(newValue);
                                const isValid = await trigger('activityForwardFragnet');
                                if (isValid) {
                                    onFiltersChanged({ [field.name]: newValue });
                                }
                            }}
                            isError={Boolean(errors.activityForwardFragnet)}
                        />
                    )}
                    name={'activityForwardFragnet'}
                    control={control}
                    rules={{
                        validate: {
                            activityFragnetValidation: (value) => {
                                return (
                                    !Boolean(watch('activityFragnet') && value) ||
                                    'You can only select one filter at a time: either "Activity Fragnet" or "Activity Forward Fragnet."'
                                );
                            },
                        },
                    }}
                />
            </div>
            {errors.activityForwardFragnet && (
                <CustomizedFormErrorMessage text={errors.activityForwardFragnet.message} />
            )}
        </>
    ) : null;
};
